import { render, staticRenderFns } from "./SmsConfirmModal.vue?vue&type=template&id=0c5c9258&"
import script from "./SmsConfirmModal.vue?vue&type=script&lang=js&"
export * from "./SmsConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports